<span class="badge" [class]="variant()">{{ label() }}</span>
